import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { CreateSubChildCategoryPayload } from "./createSubChildCategory.types";

export const requestCreateSubChildCategory = async (
  body: CreateSubChildCategoryPayload
): Promise<Category> => {
  return await instance.post(ApiRoutesCategories.SubChildCategory, body);
};
